<template>
  <div class="hamburger" :class="{ open: open }">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script setup lang="ts">
defineProps({
  open: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped lang="scss">
.hamburger {
  width: 18px;
  height: 14px;
  position: relative;
  top: -2px;

  span {
    width: 18px;
    height: 2.4px;
    background: $white;
    border-radius: 1px;
    position: absolute;
    top: 0;
    left: 0;
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
    transform-origin: center center;

    &:nth-child(1) {
      top: 0;
    }

    &:nth-child(2) {
      top: 7px;
    }

    &:nth-child(3) {
      top: 14px;
    }
  }

  &.open {
    span {
      &:nth-child(1) {
        transform: rotate(45deg) translateY(5px) translateX(5px);
      }

      &:nth-child(2) {
        transform: scaleX(0);
      }

      &:nth-child(3) {
        transform: rotate(-45deg) translateY(-5px) translateX(5px);
      }
    }
  }

  &--blue {
    span {
      background: $main-cta;
    }
  }
}
</style>
